import Vue from "vue"
import axios from 'axios'
import md5 from 'js-md5'
import { Message } from 'element-ui'

// 配置管理
const API_CONFIG = {
  BASE_URL: process.env.VUE_APP_API_URL,
  TIMEOUT: 30 * 1000,
  RETRY_COUNT: 3,
  RETRY_DELAY: 1000
}

// 创建新的axios实例
const service = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  timeout: API_CONFIG.TIMEOUT
})
// 请求拦截器
service.interceptors.request.use(
  config => {
    config.headers = setHeader(config)
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
// 设置请求头
function setHeader (config) {
  const auth = Vue.prototype.$getAuth()
  if (!auth.uuid) {
    return config.headers || {}
  }

  const { uuid, secret_key } = auth
  const timestamp = Date.now().toString()
  const code = generateRandomCode()

  return {
    ...config.headers,
    Uuid: uuid,
    Timestamp: timestamp,
    Code: code,
    Sign: generateSign(uuid, secret_key, timestamp, code)
  }
}

// 生成随机码
function generateRandomCode () {
  return Math.random().toString(36).slice(-8)
}

// 生成签名
function generateSign (uuid, secret_key, timestamp, code) {
  const signedStr = `${uuid}${secret_key}${timestamp}${code}`
  return md5(signedStr)
}

// 响应拦截器
service.interceptors.response.use(
  response => {
    const { code, msg, data } = response.data

    if (code !== 200) {
      handleResponseError(code, msg, data)
    }

    return response.data
  },
  error => {
    handleError(error)
    return Promise.reject(error)
  }
)

// 处理响应错误
function handleResponseError (code, msg, data) {
  if (code > 400) {
    // 清空认证信息并重新登录
    sessionStorage.removeItem('auth');
    localStorage.removeItem('auth');
    setTimeout(() => {
      location.reload()
    }, 1000)
    return
  }

  if (!data) {
    Message.error(msg)
  }
}

// 处理请求错误
function handleError (error) {
  let errorMessage = '连接服务器失败'

  if (error?.response) {
    errorMessage = getErrorMessage(error.response.status)

    // 特定状态码处理
    if (error.response.status === 404) {
      window.location.href = '/NotFound'
    }
  } else if (error?.message?.includes('timeout')) {
    errorMessage = '服务器响应超时，请刷新当前页'
  }

  Message.error(errorMessage)
}

// 根据状态码获取错误消息
function getErrorMessage (status) {
  const statusMessages = {
    400: '错误请求',
    401: '未授权，请重新登录',
    403: '拒绝访问',
    404: '请求错误,未找到该资源',
    405: '请求方法未允许',
    408: '请求超时',
    500: '服务器端出错',
    501: '网络未实现',
    502: '网络错误',
    503: '服务不可用',
    504: '网络超时',
    505: 'http版本不支持该请求'
  }

  return statusMessages[status] || `连接错误${status}`
}

export default service